import { createContext, useContext, useState, ReactNode } from 'react';

interface CallingContextType {
  isCallInProgress: boolean;
  setCallInProgress: (inProgress: boolean) => void;
}

const CallingContext = createContext<CallingContextType | undefined>(undefined);

export function CallingProvider({ children }: { children: ReactNode }) {
  const [isCallInProgress, setIsCallInProgress] = useState(false);

  const setCallInProgress = (inProgress: boolean) => {
    setIsCallInProgress(inProgress);
  };

  return (
    <CallingContext.Provider value={{ isCallInProgress, setCallInProgress }}>
      {children}
    </CallingContext.Provider>
  );
}

export function useCallingState() {
  const context = useContext(CallingContext);
  if (context === undefined) {
    throw new Error('useCallingState must be used within a CallingProvider');
  }
  return context;
}
